<template>
  <div v-if="bank_statement_data.length > 0">
    <BankStatementVerificationReport
      :bank_statement_data="finch_bank_statement_data"
      :sheet_elements="sheet_elements"
    />
  </div>
<div class="card shadow-sm border-info border-opacity-25 my-4 rounded-3" v-else>
    <div class="card-body d-flex flex-column justify-content-center align-items-center p-4">
        <i class="bi bi-info-circle-fill text-info fs-3 mb-3"></i>
        <p class="mb-0 text-xs text-center text-muted">
            The verification service was completed using the custom form because the
            bank was not supported by the verification service. Please note that the
            documents are available under the <span class="fw-bold">Documents</span> tab under customer data.
        </p>
    </div>
</div>
</template>

<script>
import BankStatementVerificationReport from "@/layouts/pdf_reporting/finch_bank_statement/BankStatementVerificationReport.vue";

export default {
  name: "AllInOneBankVerificationReport",
  components: {
    BankStatementVerificationReport,
  },
  props: {
    sheet_elements: {
      type: String,
      default: ".sheet",
      required: false,
    },
    all_in_one_data: {
      type: Object,
      default: () => ({}),
      required: false,
    },
  },
  computed: {
    safe_all_in_one_data() {
      return this.all_in_one_data || {};
    },
    // Extract bank statement data from all_in_one_data
    bank_statement_data() {
      return this.safe_all_in_one_data?.account_data || [];
    },
    // Create finch_bank_statement_data from all_in_one_data
    finch_bank_statement_data() {
      var data = {
        "data": this.bank_statement_data || [],
      }
      return data;
    },
  },
};
</script>
